// @flow

import { type PendingIncomingPayment } from './types';

export function getSafeOxxopayBarcode(incomingPayment: PendingIncomingPayment): string {
  const oxxopayBarcode = incomingPayment['oxxopay_barcode'];
  if (!oxxopayBarcode)
    throw new Error('Oxxopay: Invalid state - There is no oxxopay_barcode property for this payment');

  return oxxopayBarcode;
}
